/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/*PDP add "Sold Out" label for OOS variant dropdown*/
$('#select_hidden_vars option[class="disabledOption"]').each(function(){
  var curSize = $(this).data('opt-size');
  var variant_id=$(this).attr('data-variant-id')
  //console.log(curSize)
  $('.Popover__ValueList button[type="button"][data-value="'+curSize+'"]').addClass('unavailable');
  $('.Popover__ValueList button[type="button"][data-value="'+curSize+'"]').addClass('BIS_trigger').attr('data-variant-id',variant_id)
  $('.Popover__ValueList button[type="button"][data-value="'+curSize+'"]').html('<span>'+curSize+'</span>' + ' - (Notify Me)');
  //console.log($('#product-select-option-1 option[value="'+curSize+'"]'))
});



//   fetch(url+'time='+new Date().getTime()+'&p='+handle)
//   .then((res) => res.text())
//   .then((html) => {
//     var prods = $(html).find('.ProductList--grid .xProductItem .ProductItem__ColorSwatchList');
//     //       console.log(prods)
//     $('.CollectionInner__Products .ProductItem[data-handle="'+handle+'"] .ProductItem__ColorSwatchList').empty().append(prods);
//   });

// var color_res = [];
// function make_api_call(handle){
//   return fetch(url+'time='+new Date().getTime()+'&p='+handle)
//   .then((res) => res.text())
//   .then((html) => {
//     console.log(handle)
//     var prods = $(html).find('.ProductList--grid .xProductItem .ProductItem__ColorSwatchList');
//     //       console.log(prods)
//     $('.CollectionInner__Products .ProductItem[data-handle="'+handle+'"] .ProductItem__ColorSwatchList').empty().append(prods);
//   })
// }

// async function processUsers(){
//   let result;
//   for(let i = 0; i < window.product_handles.length; i++){
//     result = await make_api_call(window.product_handles[i]);
//     color_res.push(result);
//   }
//   return color_res;
// }


// async function doTask(){
//   let result = await processUsers();
//   console.log(result);
// }

// doTask();

function callbackFunction(resp) {

  var msg;
  var errLbl = $('<label>').attr('style','color: red;padding: 15px 0 0px;').attr('class','error-msg').attr('id','error-msg');
  if (resp.result === 'success') {
    // Do stuff
    //alert('hey');
    $('label.error-msg').html('');
    $('.join-form').slideUp('slow');
    $('.newsletterthanks').slideDown('slow');

    if ($.cookie('MCPopupshow') !== 'undefined') {
      $.cookie('MCPopupshow', 'false', {
        expires: 365,
        path: '/'
      });
    }

  } else {
    var index = -1;
    try {
      var parts = resp.msg.split(' - ', 2);
      if (parts[1] === undefined) {
        msg = resp.msg;
      } else {
        var i = parseInt(parts[0], 10);
        if (i.toString() === parts[0]) {
          index = parts[0];
          msg = parts[1];
        } else {
          index = -1;
          msg = resp.msg;
        }
      }
    } catch (e) {
      index = -1;
      msg = resp.msg;
    }
    errLbl.html(msg);
    $('.newsletter-submit').after(errLbl);
    //           $('.error-msg').html(msg);

  }
  $('.Newsletter-Form-Desktop').find('input[type="submit"]').delay(3000).removeClass('p-loader');
  $('.Newsletter-Form-Desktop [type="submit"]').removeAttr('disabled');

}


// function getWishlistItems(){
//   try{
//     window._swat.fetch( function(r) {
//       var wishlistItems = r;
//       $.each(wishlistItems,function(indx,val){
//         var variantId = val.epi;
//         var variantProd = $('.swym-add-to-wishlist-view-product.product_'+variantId);
//         variantProd.addClass('disabled swym-added');
//         variantProd.attr('data-action',"remove");
//       })
//       console.log('getWishlistItems called')
//     });
//   }
//   catch{
//   }
// }

// function initAddToWishlist(){
//   var wishlistButtons = $(".swym-add-to-wishlist-view-product");
//   $(wishlistButtons).each(function(indx, val){
//     var wishlistButton = $(this);
//     wishlistButton.on("click", function(e){
//       var action = $(this).attr('data-action');
//       var btn = $(this);
//       console.log("main:=> ",action);
//       if(action=="remove"){
//         var variantArr = {};
//         var FinalvariantArr = new Array();
//         var newNum = String(btn.data('variant-title'));
//         var newVal = btn.data('variant-id');
//         variantArr[newNum] = newVal;
//         FinalvariantArr.push(variantArr);
//         //         console.log(FinalvariantArr)
//         window._swat.removeFromWishList(
//           {
//             "epi": btn.data('variant-id'),
//             "du": btn.data('product_url'),
//             "empi": btn.data('product-id'),
//             "iu" : btn.data('variant-img'),
//             "pr": btn.data('variant-price'),
//             "variants": FinalvariantArr
//           },
//           function(r) {
//             btn.removeClass('disabled swym-added');
//             btn.attr('data-action',"add");
//             console.log('Removed from wishlist');
//           }
//         );
//         console.log(action);
//       }
//       else{
//         console.log(action);
//         var variantArr = {};
//         var FinalvariantArr = new Array();
//         var newNum = String(btn.data('variant-title'));
//         var newVal = btn.data('variant-id');
//         variantArr[newNum] = newVal;
//         FinalvariantArr.push(variantArr);
//         //         console.log(FinalvariantArr)
//         window._swat.addToWishList(
//           {
//             "epi": btn.data('variant-id'),
//             "du": btn.data('product_url'),
//             "empi": btn.data('product-id'),
//             dt: btn.data('product-title') + " - " + btn.data('variant-title'),
//             "pt":btn.data('product-title'),
//             "iu" : btn.data('variant-img'),
//             "pr": btn.data('variant-price'),
//             "variants": FinalvariantArr
//           },
//           function(r) {
//             btn.addClass('disabled swym-added');
//             btn.attr('data-action',"remove");
//             console.log('Added to wishlist');
//           }
//         );
//       }
//     });
//   });
//   console.log('initAddToWishlist called')
// }

// function refineProductTitle(){
//   $.each($('.swym-title a'),function(indx,val){
//     var title= String($(this).text());
//     var char_index = title.indexOf('/');
//     if(char_index>=0){
//       var final_Title = title.substring(0,char_index);
//       $(this).text(final_Title);
//     }
//   }) 
// }
// let stateCheck2 = setInterval(() => {
//                               if (document.readyState === 'complete') {
//   clearInterval(stateCheck2);
//   refineProductTitle();
//   $('.swym-item-grid').css({'opacity':1});
// } }, 1500);

// $(window).bind("load", function() {
//   //   $('.mm-page.mm-slideout .fs-mobile.fs-wrapper .fs-timeline-detail').remove();
//   //   $('.mm-page.mm-slideout .fs-desktop.fs-wrapper .fs-timeline-detail').remove();
//   setTimeout(function() {
//     getWishlistItems();
//     initAddToWishlist();
//     window._swat.wishlistCount( function(r) {$('a.wishlist-link span.wishlist-count').html(r) });

//   },300);


// });


function addEventListenerStamped(el, eventName, handler) { 
  if (el.addEventListener) { el.addEventListener(eventName, handler); }
  else { el.attachEvent('on' + eventName, function () { handler.call(el); }); } 
}




$(document).ready(function(){
  $('body').on('click','span.stamped-product-reviews-badge',function(e){
    var btn = $('[data-reviews-tab] button');
//     console.log(btn.attr('aria-expanded'))
    if(btn.attr('aria-expanded')!='true'){
      btn.trigger('click');
    }
  })

  // console.log('loaded')
//   $('.Footer__Newsletter').ajaxChimp({
//     url: 'https://matissefootwear.us6.list-manage.com/subscribe/post?u=65d43255eabe8eb482f6d5cf1&amp;id=02545d42fc',
//     callback: function(resp){
//       var msg;
//       var ele = $('.Footer__Newsletter');
//       $('label.resp-msg',ele).hide().html('');
//       if (resp.result === 'success') {
//         msg = resp.msg;
//         $('label.resp-msg',ele).html(msg);
//         $('label.resp-msg',ele).removeClass('error-msg').addClass('success-msg').attr('style','display:block');
// //         $('.join-form').slideUp('slow');
// //         $('.newsletterthanks').slideDown('slow');

// //         if ($.cookie('MCPopupshow') !== 'undefined') {
// //           $.cookie('MCPopupshow', 'false', {
// //             expires: 365,
// //             path: '/'
// //           });
// //         }

//       }
//       else {
//         var index = -1;
//         try {
//           var parts = resp.msg.split(' - ', 2);
//           if (parts[1] === undefined) {
//             msg = resp.msg;
//           } else {
//             var i = parseInt(parts[0], 10);
//             if (i.toString() === parts[0]) {
//               index = parts[0];
//               msg = parts[1];
//             } else {
//               index = -1;
//               msg = resp.msg;
//             }
//           }
//         } catch (e) {
//           index = -1;
//           msg = resp.msg;
//         }
//         msg = resp.msg;
//         if(msg.indexOf('0 - Please enter a value')>=0){
//         	msg='Please enter an email address';
//         }
//         $('label.resp-msg',ele).html(msg);
//         $('label.resp-msg',ele).removeClass('success-msg').addClass('error-msg').attr('style','display:block');
//         //           $('.error-msg').html(msg);
//       }
// //       $('.Newsletter-Form-Desktop').find('input[type="submit"]').delay(3000).removeClass('p-loader');
// //       $('.Newsletter-Form-Desktop [type="submit"]').removeAttr('disabled');
//     }
//   });
//   $('.NewsletterPopup__Form').ajaxChimp({
//     url: 'https://matissefootwear.us6.list-manage.com/subscribe/post?u=65d43255eabe8eb482f6d5cf1&amp;id=02545d42fc',
//     callback: function(resp){
//       var msg;
//       var ele = $('.NewsletterPopup__Form');
//       $('label.resp-msg',ele).hide().html('');
//       if (resp.result === 'success') {
//         msg = resp.msg;
//         $('label.resp-msg',ele).html(msg);
//         $('label.resp-msg',ele).removeClass('error-msg').addClass('success-msg').attr('style','display:block');
//         //         $('.join-form').slideUp('slow');
//         //         $('.newsletterthanks').slideDown('slow');

//         //         if ($.cookie('MCPopupshow') !== 'undefined') {
//         //           $.cookie('MCPopupshow', 'false', {
//         //             expires: 365,
//         //             path: '/'
//         //           });
//         //         }

//       }
//       else {
//         var index = -1;
//         try {
//           var parts = resp.msg.split(' - ', 2);
//           if (parts[1] === undefined) {
//             msg = resp.msg;
//           } else {
//             var i = parseInt(parts[0], 10);
//             if (i.toString() === parts[0]) {
//               index = parts[0];
//               msg = parts[1];
//             } else {
//               index = -1;
//               msg = resp.msg;
//             }
//           }
//         } catch (e) {
//           index = -1;
//           msg = resp.msg;
//         }
//         msg = resp.msg;
//         if(msg.indexOf('0 - Please enter a value')>=0){
//         	msg='Please enter an email address';
//         }
//         $('label.resp-msg',ele).html(msg);
//         $('label.resp-msg',ele).removeClass('success-msg').addClass('error-msg').attr('style','display:block');
//         //           $('.error-msg').html(msg);
//       }
//       //       $('.Newsletter-Form-Desktop').find('input[type="submit"]').delay(3000).removeClass('p-loader');
//       //       $('.Newsletter-Form-Desktop [type="submit"]').removeAttr('disabled');
//     }
//   });
  

  
//   var element = document.querySelector('[data-products-section]');

//   var handles = element.getAttribute('data-handles').split(', ');

//   var query = handles
//   .map((handle) => (`handle:"${handle}"`))
//   .join(' OR ');

//   var template_suffix = 'custom';

//   var url = `/collections/get-all-products?view=get-all-products&`;
//   if($('body').hasClass('template-collection')){
//     $.each(window.product_handles,function(indx,handle){
//       fetch(url+'time='+new Date().getTime()+'&prod_handle='+handle,{
//         credentials: 'same-origin',
//         method: 'GET',
//         cache: 'no-store',
//         headers: {
//           'Content-Type': 'application/x-www-form-urlencoded',
//           'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
//         }
//       })
//       .then((res) => res.text())
//       .then((html) => {
//         var prods = $(html).find('.ProductList--grid .xProductItem .ProductItem__ColorSwatchList');
//         //       console.log(prods)
//         $('.CollectionInner__Products .ProductItem[data-handle="'+handle+'"] .ProductItem__ColorSwatchList').empty().append(prods);
//       });
//     })
//   }

  // Example

});

// Listening for reviews widget loaded event
// addEventListenerStamped(document, 'stamped:reviews:loaded', function(e) {
//   console.log(e.detail);
//   if(e.detail==null){
//     console.log(e.detail,parseInt($('.stamped-container').attr('data-count')))
//     if(parseInt($('.stamped-container').attr('data-count'))>0){
//       $('[data-reviews-tab],.stamped-main-badge').show();
//       return true;
//     }
// //     else{
//       $('[data-reviews-tab],.stamped-main-badge').hide();
// //     }
//   }
//   else{
//     $('[data-reviews-tab],.stamped-main-badge').show();
//   }
// });